import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from "@/shared";
import { useUiStore } from "@/store/ui";
import { useMutation, useQueryClient } from "@tanstack/react-query";

const {post } = erpApi();


type ICambiarEstadoAceptacionContrato = {
  id_preventa: number;
  estado_aceptacion: boolean;
}

export const useFetchCambioEstadoMetodoAceptacion = () => {
  const queryClient = useQueryClient();
  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: putCambioEstadoMetodoAceptacion,
    onSuccess: (res) => {
      queryClient.invalidateQueries({ queryKey: ['metodo-aceptacion'] });
      if (res.code != 200) {
        setAlert(true, res.message, res.status);
      }
    },
  });
};


export const putCambioEstadoMetodoAceptacion = async (data: ICambiarEstadoAceptacionContrato) => {
  const res = await post<string>(`${urlBackend}api/v1/cambiar-estado-aceptacion-contrato/`, data, false);
  return res;
};